<template>
  <page no-styling>
    <coupon-list :coupons="coupons"/>
  </page>
</template>

<script>
import CouponList from '@/components/CouponList.vue';

export default {
  name: 'coupon-preview-view',

  components: { CouponList },

  props: {
    campaign: Object,
  },

  computed: {
    coupons() {
      if (this.campaign) {
        return this.campaign.coupons.map(coupon => ({
          ...coupon,
          campaign: this.campaign,
        })).reverse();
      }

      return [];
    },
  },
};
</script>
